<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("LOCATIONS.EDIT_LOCATION") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <location-form
              :loading="loading"
              :locationData="location"
              :formErrors="formErrors"
              @locationSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import LocationForm from "./partials/LocationForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultLocation from "./defaultLocation";

export default {
  layout: "DashboardLayout",

  components: { LocationForm },
  mixins: [alertLeave],

  data() {
    return {
      location: cloneDeep(defaultLocation),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("locations/get", id);
        this.location = this.$store.getters["locations/location"];
        this.location = {
          ...this.location,
          manager: this.location?.manager?.id
            ? this.location?.manager
            : {
                type: "users",
                id: null,
              },
        };
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Locations" });
    },

    viewLocation() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Location",
        params: { id: this.location.id },
      });
    },

    async handleSubmit(location) {
      this.loading = true;

      const locationData = cloneDeep(location);
      if (!locationData.organization.id) {
        delete locationData.organization;
      }
      if (locationData.reseller) {
        if (!locationData.reseller.id) {
          delete locationData.reseller;
        }
      }

      try {
        await this.$store.dispatch("locations/update", locationData);
        this.$notify({
          type: "success",
          message: this.$t("LOCATIONS.LOCATIONS_UPDATED"),
        });
        this.viewLocation();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
